<template>
  <div>
    <div class="w-full full-login font-poppins">
      <div class="block sm:flex justify-center align-items-center">
        <form
          @submit.prevent="sendEmail"
          class="xl:h-auto flex justify-center"
          v-if="step === 1"
        >
          <div
            class="my-10 mb-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-8/12 w-full"
            style="box-shadow: 0px 4px 50px 0px #00000026"
          >
            <img
              v-if="urlOriginIsBrandIn"
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            />
            <img
              v-else
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo.png`)"
            />
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                <h1 class="text-xl text-theme-4 font-bold">
                  Olvidé mi contraseña
                </h1>
              </div>
            </div>
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                Introduce tu correo de Brand In donde recibirás un código para
                reestablecer tu contraseña
              </div>
            </div>
            <div class="intro-x mt-2 px-8">
              <div class="intro-x text-theme-2 text-left">Correo</div>
              <input
                id="validation-form-2"
                v-model.trim="email"
                type="email"
                name="email"
                required
                class="intro-x login__input form-control py-3 px-4 border-theme-3 block mb-2"
                :class="{ 'border-theme-6': v$.email.$error }"
                placeholder="example@gmail.com"
              />
              <template v-if="v$.email.$errors">
                <div
                  v-for="(error, index) in v$.email.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo correo es requerido</strong
                  >
                  <strong v-else-if="error.$validator === 'email'"
                    >El campo correo debe ser un email válido</strong
                  >
                </div>
              </template>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center">
              <button
                type="submit"
                :disabled="v$.email.$errors.length > 0 || email.length === 0"
                class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
              >
                Enviar
              </button>
            </div>
            <div
              class="intro-x mt-10 text-theme-4 text-center text-base mx-8 pb-4"
            >
              <router-link :to="{ name: 'login' }" tag="a">
                Regresar
              </router-link>
            </div>
          </div>
        </form>
        <form
          v-else-if="step === 2"
          @submit.prevent="validateOtp"
          class="xl:h-auto flex justify-center"
        >
          <div
            class="my-10 mb-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-8/12 w-full"
            style="box-shadow: 0px 4px 50px 0px #00000026"
          >
            <img
              v-if="urlOriginIsBrandIn"
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            />
            <img
              v-else
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo.png`)"
            />
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                <h1 class="text-xl text-theme-4 font-bold">
                  Olvidé mi contraseña
                </h1>
              </div>
            </div>
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                Ingresa el código de verificación que enviamos al correo:
                {{ email }}
              </div>
            </div>
            <div class="intro-x mt-2 px-8">
              <div class="intro-x text-theme-2 text-left">Código</div>
              <input
                id="validation-form-2"
                v-model.trim="code"
                type="text"
                name="code"
                required
                class="intro-x login__input form-control py-3 px-4 border-theme-3 block mb-2"
                :class="{ 'border-theme-6': v$.code.$error }"
                placeholder="6 dígitos"
                :maxlength="6"
                :minlength="6"
              />
              <template v-if="v$.code.$errors">
                <div
                  v-for="(error, index) in v$.code.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  <strong v-if="error.$validator === 'required'"
                    >El campo código es requerido</strong
                  >
                </div>
              </template>
            </div>
            <div class="flex justify-center mt-2 px-8">
              <button
                type="button"
                class="text-theme-2 cursor-pointer hover:text-theme-4 hover:underline disabled:opacity-50 disabled:!cursor-not-allowed"
                :disabled="resendTimer > 0"
                @click="sendEmail"
              >
                Reenviar código {{ resendTimer > 0 ? `(${resendTimer})` : '' }}
              </button>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center">
              <button
                type="submit"
                :disabled="v$.code.$invalid || code.length === 0"
                class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
              >
                Enviar
              </button>
            </div>
            <div
              class="intro-x mt-10 text-theme-4 text-center text-base mx-8 pb-4"
            >
              <router-link :to="{ name: 'login' }" tag="a">
                Regresar
              </router-link>
            </div>
          </div>
        </form>
        <form
          v-else-if="step === 3"
          @submit.prevent="storePassword"
          class="xl:h-auto flex justify-center"
        >
          <div
            class="my-10 mb-4 mx-4 px-4 py-8 bg-white rounded-md sm:w-8/12 w-full"
            style="box-shadow: 0px 4px 50px 0px #00000026"
          >
            <img
              v-if="urlOriginIsBrandIn"
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
            />
            <img
              v-else
              alt="COTIZADOR"
              class="-intro-x -mt-16"
              style="display: block; margin: auto; width: 200px"
              :src="require(`@/assets/images/COT-img/logo.png`)"
            />
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                <h1 class="text-xl text-theme-4 font-bold">
                  Olvidé mi contraseña
                </h1>
              </div>
            </div>
            <div class="intro-x mt-8 px-8">
              <div class="intro-x text-theme-2 text-center text-base">
                Crear nueva contraseña
              </div>
            </div>
            <div class="intro-x mt-2 px-8">
              <div class="flex flex-col">
                <div class="intro-x text-theme-2 text-left">
                  Nueva contraseña
                </div>
                <div class="input-group mt-1">
                  <input
                    :type="inputPasswordShow ? 'text' : 'password'"
                    class="form-control p-3 text-base"
                    placeholder="Nueva contraseña"
                    style="border-right-width: 0"
                    ref="password"
                    v-model="password"
                    @cut.prevent
                    @copy.prevent
                    @paste.prevent
                    required
                  />
                  <div
                    class="input-group-text flex cursor-pointer"
                    style="border-left-width: 0; background: white"
                    @click="
                      changeInputShowPassword({
                        ref: 'password',
                        input: 'inputPasswordShow'
                      })
                    "
                  >
                    <EyeIcon
                      class="w-4 h-4 my-auto"
                      v-if="!inputPasswordShow"
                    />
                    <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                  </div>
                </div>
                <template v-if="v$.password.$errors">
                  <div
                    v-for="(error, index) in v$.password.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo nueva contraseña es requerido</strong
                    >
                  </div>
                </template>
              </div>
              <div class="intro-x mt-3 px-10 text-xs flex flex-col">
                <span>
                  Debe incluir
                  <span :class="{ 'text-theme-6': !passwordHasMinLenght }">
                    mínimo 8 caracteres
                  </span>
                  y cumplir 3 de estas 4 características:
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-40': !passwordHasUpperCase }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos una
                  mayúscula
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-40': !passwordHasLowerCase }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />
                  Al menos una minúscula
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-40': !passwordHasNumber }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos un
                  número
                </span>
                <span
                  class="mt-1 flex"
                  :class="{ 'opacity-40': !passwordHasSpecialCharacter }"
                >
                  <CheckCircleIcon class="w-3 h-3 my-auto mr-1" />Al menos un
                  caracter especial (#$%&_) o puntuación (,.)
                </span>
              </div>
              <div class="flex flex-col">
                <div class="intro-x text-theme-2 text-left">
                  Confirmar contraseña
                </div>
                <div class="input-group mt-1">
                  <input
                    :type="inputPasswordConfirmationShow ? 'text' : 'password'"
                    class="form-control p-3 text-base"
                    placeholder="Confirmar contraseña"
                    style="border-right-width: 0"
                    ref="passwordConfirmation"
                    v-model="passwordConfirmation"
                    @cut.prevent
                    @copy.prevent
                    @paste.prevent
                    required
                  />
                  <div
                    class="input-group-text flex cursor-pointer"
                    style="border-left-width: 0; background: white"
                    @click="
                      changeInputShowPassword({
                        ref: 'passwordConfirmation',
                        input: 'inputPasswordConfirmationShow'
                      })
                    "
                  >
                    <EyeIcon
                      class="w-4 h-4 my-auto"
                      v-if="!inputPasswordConfirmationShow"
                    />
                    <EyeOffIcon class="w-4 h-4 my-auto" v-else />
                  </div>
                </div>
                <template v-if="v$.passwordConfirmation.$errors">
                  <div
                    v-for="(error, index) in v$.passwordConfirmation.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo confirmar contraseña es requerido</strong
                    >
                  </div>
                </template>
                <span
                  class="text-xs ml-1 text-theme-6"
                  v-if="
                    password?.length >= 8 &&
                    passwordConfirmation?.length >= 8 &&
                    password !== passwordConfirmation
                  "
                  >Las contraseñas no coinciden</span
                >
              </div>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center">
              <button
                type="submit"
                :disabled="
                  v$.password.$errors.length > 0 ||
                  password.length === 0 ||
                  v$.passwordConfirmation.$errors.length > 0 ||
                  passwordConfirmation.length === 0 ||
                  password !== passwordConfirmation
                "
                class="btn btn-quotation-login text-base py-3 px-4 w-60 border-0"
              >
                Enviar
              </button>
            </div>
            <div
              class="intro-x mt-10 text-theme-4 text-center text-base mx-8 pb-4"
            >
              <router-link :to="{ name: 'login' }" tag="a">
                Regresar
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.full-login {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: center;
}
</style>

<script>
import useVuelidate from '@vuelidate/core'
import { email, required, minLength, maxLength } from '@vuelidate/validators'
import { getFirstErrorMessage } from '@/utils/tools'

export default {
  data() {
    return {
      email: '',
      code: '',
      password: '',
      passwordConfirmation: '',
      viewForm: true,
      step: 1,
      inputPasswordShow: false,
      inputPasswordConfirmationShow: false,
      token: '',
      resendTimer: 0,
      resendTimerInterval: null
    }
  },
  setup() {
    return { v$: useVuelidate() }
  },
  beforeMount() {
    cash('html').addClass('unauthenticated')
  },
  validations() {
    return {
      email: { required, email, $autoDirty: true },
      code: {
        required,
        minLength: minLength(6),
        maxLenght: maxLength(6),
        $autoDirty: true
      },
      password: {
        required,
        $autoDirty: true
      },
      passwordConfirmation: {
        required,
        $autoDirty: true
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  methods: {
    async sendEmail() {
      this.resendTimer = 60
      this.resendInterval = setInterval(() => {
        this.resendTimer--
        if (this.resendTimer === 0) {
          clearInterval(this.resendInterval)
        }
      }, 1000)
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post(
          'otp/send-otp-email-to-reset-password',
          {
            email: this.email
          }
        )
        this.step = 2
        this.$toast.success(response.data.message, {
          position: 'top'
        })
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async validateOtp() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.post('otp/validate-otp', {
          email: this.email,
          code: this.code
        })
        this.token = response.data.temporal_token
        this.step = 3
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    async storePassword() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          'auth/modify-password',
          {
            email: this.email,
            code: this.code,
            new_password: this.password
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        this.$toast.success('Contraseña modificada correctamente', {
          position: 'top'
        })
        this.$router.push({ name: 'login' })
      } catch (error) {
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    changeInputShowPassword({ ref, input }) {
      this[input] = !this[input]
      this.$refs[ref].focus()
      setTimeout(() => {
        const length = this.$refs[ref].value.length
        this.$refs[ref].setSelectionRange(length, length)
      })
    }
  },
  computed: {
    urlOriginIsBrandIn() {
      const currentHost = (window.location?.host || '').replace(/^www\./, '')
      const brandInDomain = (process.env.VUE_APP_BRAND_IN_DOMAIN || '').replace(
        /^www\./,
        ''
      )
      return currentHost === brandInDomain
    },
    passwordHasMinLenght() {
      return this.password?.length >= 8
    },
    passwordHasLowerCase() {
      return /[a-z]/.test(this.password || '')
    },
    passwordHasUpperCase() {
      return /[A-Z]/.test(this.password || '')
    },
    passwordHasNumber() {
      return /\d/.test(this.password || '')
    },
    passwordHasSpecialCharacter() {
      const specialChars = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
      return specialChars.test(this.password || '')
    },
    checkValidationPassword() {
      return (
        this.password?.length >= 8 &&
        this.password === this.confirmPassword &&
        this.passwordHasLowerCase +
          this.passwordHasUpperCase +
          this.passwordHasNumber +
          this.passwordHasSpecialCharacter >=
          3
      )
    }
  }
}
</script>
